import Header from './components/Header';
import Hero from './components/Hero';
import CarouselSection from './components/CarouselSection';
import FAQSection from './components/FAQSection';
import CommentsSection from './components/CommentsSection';
import CardsSection from './components/CardsSection';
import RankingSection from './components/RankingSection';
import UpdatesSection from './components/UpdatesSection';
import AppSection from './components/AppSection';
import MediaSection from './components/MediaSection';
import TopicsSection from './components/TopicsSection';
import IndexSection from './components/IndexSection';
import FeaturesSection from './components/FeaturesSection';
import ContactSection from './components/ContactSection';
import AboutSection from './components/AboutSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <CarouselSection />
        <FAQSection />
        <CommentsSection />
        <CardsSection />
        <RankingSection />
        <UpdatesSection />
        <AppSection />
        <MediaSection />
        <TopicsSection />
        <IndexSection />
        <FeaturesSection />
        <ContactSection />
        <AboutSection />
      </main>
      <Footer />
    </>
  );
}